import {selectLanguageCode} from '@/state/selectors/global';
import {getState} from '@/state/store';
import dateTimeUtils from '@/utils/dateTimeUtils';

const getLocalizedDayAndShortMonth = (date) => {
    const languageCode = selectLanguageCode(getState());
    const result = dateTimeUtils.getDayAndShortMonth(new Date(date), languageCode);

    return result;
};

const getLocalizedDayMonthAndYear = (date) => {
    const languageCode = selectLanguageCode(getState());

    return dateTimeUtils.getDayMonthAndYear(new Date(date), languageCode);
};

const getLocalizedMonth = (date) => {
    const languageCode = selectLanguageCode(getState());

    return dateTimeUtils.getMonth(new Date(date), languageCode);
};

export default {
    getLocalizedDayAndShortMonth,
    getLocalizedDayMonthAndYear,
    getLocalizedMonth,
};
